import { render } from "./ListUrgentPkt.vue?vue&type=template&id=4ea698a6&scoped=true"
import script from "./ListUrgentPkt.vue?vue&type=script&lang=js"
export * from "./ListUrgentPkt.vue?vue&type=script&lang=js"

import "./ListUrgentPkt.vue?vue&type=style&index=0&id=4ea698a6&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea698a6"]])

export default __exports__